// extracted by mini-css-extract-plugin
export default {"shell":"r6ovd3DdlNaRmKgUP5J5","toolbar":"iTLbXqlfe9UydUnUWSiQ","root":"F86F5AJSBFGDvNy03w0d","page":"oCp7F6zpuU08eHKivm36"};